/* eslint-disable import/no-default-export */
import React from 'react';
import styles from './link.less';
import classNames from 'classnames';

interface LinkProps {
  children: React.ReactNode;
  link: string;
  isPrimary: boolean;
  onClick?: React.EventHandler<React.MouseEvent<HTMLElement>>;
  openInNewTab?: boolean;
  className?: string;
}

export const ButtonLink = ({
  children,
  link,
  isPrimary,
  onClick,
  openInNewTab,
  className,
}: LinkProps) => {
  const buttonStyle: string = isPrimary
    ? styles.primaryButtonLink
    : styles.defaultButtonLink;
  const linkTarget: string = openInNewTab ? '_blank' : '';

  return (
    <a
      href={link}
      className={classNames(buttonStyle, className)}
      onClick={onClick}
      target={linkTarget}
    >
      <span>{children}</span>
    </a>
  );
};
